import { styled } from "@mui/material/styles";

const PrintInvoicesMain = styled("div")(({ theme }) => ({}));
const InvoicesHeader = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "10px",
  "& h6": {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "36px",
    color: "#0B0B0B",
    fontFamily: "Avenir",
  },
  "& h6.invoice_Tit": {
    color: "#186AA9",
  },
}));
const InvoicesHeaderDetails = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "10px",
  "& .details": {
    width: "40%",
  },
  "& p": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "rgba(11, 11, 11, 0.5)",
    fontFamily: "Avenir",
  },
  "& h6.invoice_Tit": {
    color: "#186AA9",
  },
  "& .data": {
    "& span": {
      color: "#186AA9",
    },
  },
}));
const WeekDetails = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "end",
  alignItems: "end",
  "& span": {
    color: "#186AA9",
  },
}));
const ToDetails = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  marginBottom: "10px",

  "& h6": {
    fontFamily: "'Avenir'",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "26px",
    lineHeight: "36px",
    display: "flex",
    alignItems: "center",
    color: "#0B0B0B",
  },
}));
const HozLine = styled("div")(({ theme }) => ({
  width: "100%",
  background: "rgba(30, 39, 56, 0.6)",
  border: "1px solid #848485",
  margin: "20px 0px",
}));
const DescriptionList = styled("div")(({ theme }) => ({
  "& .descTit": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "6px",
    borderBottom: "1px solid #848485",
    marginBottom: "20px",
    "& h6": {
      fontFamily: "'Open Sans'",
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: "10px",
      lineHeight: "16px",
      letterSpacing: "1.5px",
      textTransform: "uppercase",
      color: "#186AA9",
    },
  },
}));
const ListItems = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: "7px",
  paddingTop: "10px",
  borderBottom: "1px solid #848485",
  "& h6": {
    fontFamily: "'Open Sans'",
    fontStyle: "normal",
    fontWeight: 800,
    fontSize: "14px",
    lineHeight: "16px",
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    color: "#0B0B0B",
  },
}));
const TotalPrice = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: "7px",
  paddingTop: "7px",
  borderTop: "1px solid #848485",
  borderBottom: "1px solid #848485",
  marginTop: "40px",
  "& h6": {
    fontFamily: "'Open Sans'",
    fontStyle: "normal",
    fontWeight: 800,
    fontSize: "14px",
    lineHeight: "16px",
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    color: "#0B0B0B",
  },
  "& h6.total": {
    color: "#186AA9",
  },
}));

const Footer = styled("div")(({ theme }) => ({
  marginTop: "15px",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "16px",
  color: "rgba(11, 11, 11, 0.5)",
  fontFamily: theme.typography.fontFamily,
}));
export {
  PrintInvoicesMain,
  InvoicesHeader,
  InvoicesHeaderDetails,
  WeekDetails,
  ToDetails,
  HozLine,
  DescriptionList,
  ListItems,
  TotalPrice,
  Footer,
};
